import {gql} from 'apollo-angular';

export const CREATE_IMSGE_UPLOAD_URLS = gql`
    mutation createCustomizableImageUploadUrls($input: CreateCustomizableImageUploadUrlsInput!) {
        createCustomizableImageUploadUrls(input: $input) {
            imageKey
            thumbnailImageKey
            imageUploadUrl
            thumbnailUploadUrl
        }
    }
`;
